import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// core
import { currencySelectors } from '_core/store/Currency'
import { SelectInput } from '_core/components/SelectInput'

const mapState = state => ({
  currencies: currencySelectors.getCurrencyList(state),
})

const RawCurrencyInput = props => {
  const { currencies } = props
  const options = Object.values(currencies)

  return <SelectInput {...props} options={options} />
}

RawCurrencyInput.defaultProps = {}

RawCurrencyInput.propTypes = {
  currencies: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export const CurrencyInput = connect(mapState)(RawCurrencyInput)
